var React = require('react');

function Terminal (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M4.66666 24.5H23.3333C24.6202 24.5 25.6667 23.4535 25.6667 22.1667V5.83333C25.6667 4.5465 24.6202 3.5 23.3333 3.5H4.66666C3.37983 3.5 2.33333 4.5465 2.33333 5.83333V22.1667C2.33333 23.4535 3.37983 24.5 4.66666 24.5ZM4.66666 22.1667V8.16667H23.3333L23.3345 22.1667H4.66666Z","key":0}),React.createElement("path",{"d":"M14 17.5H21V19.8333H14V17.5ZM7 12.8333L9.67516 15.5085L7 18.1837L8.64966 19.8333L12.9745 15.5085L8.64966 11.1837L7 12.8333Z","key":1})]);
}

Terminal.defaultProps = {"width":"28","height":"28","viewBox":"0 0 28 28","fill":"none"};

module.exports = Terminal;

Terminal.default = Terminal;
